// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fL7U","fullView":"styles_fullView__3piw2"};